import { clsx } from 'clsx'
import { type ComponentPropsWithRef, type JSX } from 'react'

type RadioOwnProps = {
  /**
   * The size of the component
   * @default medium
   */
  size?: 'medium' | 'small'
}

type RadioProps = Omit<ComponentPropsWithRef<'input'>, 'size' | 'type'> &
  RadioOwnProps

/**
 * Radio buttons enable the user to select one option from a set.
 */
export const Radio = (props: RadioProps): JSX.Element => {
  const { className, size = 'medium', ...inputProps } = props

  return (
    <input
      {...inputProps}
      className={clsx(
        'radio',
        size === 'medium' && 'radio_medium',
        size === 'small' && 'radio_small',
        className,
      )}
      type="radio"
    />
  )
}
